var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('CBadge',{staticClass:"badge-erp",attrs:{"color":"info","shape":"pill","title":_vm.titulo}},[_vm._v("ERP")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }